<app-navbar></app-navbar>
<div style="width: 100%;" [style.height]="smallScreen ? 'calc(100% - 60px)' : 'calc(100% - 81px)'" [style.padding-top]="smallScreen ? '60px' : '81px'">
  <router-outlet></router-outlet>
</div>
